
function HomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <rect
        x="0.715"
        y="0.715"
        width="17.57"
        height="16.57"
        rx="3.285"
        stroke="#353D46"
        strokeWidth="1.43"
      />
      <path
        d="M7 1V7L9.5 6L12 7V1"
        stroke="#353D46"
        strokeWidth="1.43"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HomeIcon